import React, { useState } from 'react';
import FormControl from '@mui/material/FormControl';
import { v4 as uuidv4 } from 'uuid';
import { Button, TextField, Grid, Typography } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
const DocumentForm = (props) => {
  const [document_, setDocument] = useState({
    name: props.document ? props.document.name : '',
    assembly_document_id: props.document ? props.document.assembly_document_id : '',
  });
  const documentTypes = props.documentTypes;

  const [errorMsg, setErrorMsg] = useState('');
  const { name, assembly_document_id } = document_;

  const handleOnSubmit = (event) => {
    event.preventDefault();
    const values = [name, assembly_document_id];
    let errorMsg = '';

    const allFieldsFilled = values.every((field) => {
      const value = `${field}`.trim();
      return value !== '' && value !== '0';
    });

    if (allFieldsFilled) {
      const document_ = {
        name,
        assembly_document_id
      };
      props.handleOnSubmit(document_);
    } else {
      errorMsg = 'Please fill out all the fields.';
    }
    setErrorMsg(errorMsg);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    switch (name) {
      default:
        setDocument((prevState) => ({
          ...prevState,
          [name]: value
        }));
    }
    if (name == 'assembly_document_id') {
        const label = documentTypes.filter((type) => type.id == value )[0].label
        setDocument((prevState) => ({
          ...prevState,
          ['name']: label 
        }));
      
    }
  };

  return (
    <div className="main-form">
      {errorMsg && <p className="errorMsg">{errorMsg}</p>}
      <FormControl >
        <Grid container spacing={2} mt={2}>
          <Grid item xs={12}>
            <InputLabel id="add-doc-type-label">Document Type</InputLabel>
            <Select
              labelId="add-doc-type-label"
              label="Type"
              name="assembly_document_id"
              value={assembly_document_id}
              onChange={handleInputChange}
              fullWidth
              required >
              {documentTypes.map((documentType)=> 
                <MenuItem value={documentType.id}>{documentType.label}</MenuItem>)}
            </Select>
          </Grid>
          <Grid item xs={12}>
            <Button variant="text" onClick={() => props.handleBack() } > 
              Back 
            </Button>
            <Button onClick={handleOnSubmit} variant="contained" type="submit" className="submit-btn">
              Submit
            </Button>
          </Grid>
        </Grid>
      </FormControl>
    </div>
  );
};

export default DocumentForm;

